import { useState } from 'react';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

interface ChannelLogoProps {
  src: string;
  name: string;
  width?: number | string;
  height?: number | string;
}

export const ChannelLogo = ({ src, name, width = '100%', height = '100%' }: ChannelLogoProps) => {
  const theme = useTheme();

  const [failed, setFailed] = useState(!src);

  if (failed) {
    return (
      <Box
        sx={{
          width,
          height,
          backgroundColor: theme.novus.placeholderBg,
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="body.sm"
          color={theme.novus.checkoutDisabledBg}
          sx={{ fontSize: 9, textAlign: 'center' }}
        >
          {name}
        </Typography>
      </Box>
    );
  }

  return (
    <CardMedia<'img'>
      component="img"
      image={src}
      alt={name}
      sx={{
        width,
        height,
        objectFit: 'contain',
        '&:hover': {
          outline: `1px solid ${theme.novus.equipmentCardBorderHover}`,
        },
      }}
      onError={() => setFailed(true)}
    />
  );
};
